// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import { MDBRow } from 'mdbreact';
import LabelRow from './LabelRow';
import EditRow from './EditRow';
import Notification from '../../notification';

const TemplateRow = ({
  template,
  rename,
  deleteTemplate,
  copyTemplate,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  const copyTemplateId = async () => {
    try {
      await navigator.clipboard.writeText(template.value);
      Notification('success', {
        message: 'Template ID copied to clipboard!',
      });
    } catch (error) {
      console.error('Unable to copy item to clipboard:', error);
    }
  };
  return (
    <tbody>
      {
        isEditing
          ? (
            <EditRow
              template={template}
              cancel={() => setIsEditing(false)}
              save={rename}
            />
          )
          : (
            <LabelRow
              template={template}
              copy={() => copyTemplate(template.value)}
              deleteTemplate={() => deleteTemplate(template.value)}
            />
          )
      }
    </tbody>
  );
};

export default TemplateRow;
